import type { CreativeItem } from "@digital-twins/shared-types";

export type CreativeUsageWarningLevel = "internal_only" | "unspecified";

/** Why this material warns on external work, or null when it is allowed. Never blocks. */
export function creativeUsageWarningLevel(
  item: Pick<CreativeItem, "usage" | "generationProvenance">,
): CreativeUsageWarningLevel | null {
  const ceiling = item.generationProvenance?.usageCeiling;
  if (item.usage === "internal_only" || ceiling === "internal_only") {
    return "internal_only";
  }
  if (item.usage !== "external_allowed") {
    return "unspecified";
  }
  return ceiling && ceiling !== "external_allowed" ? "unspecified" : null;
}

/** The link helps only if Allowed use can reach external: a source ceiling disables that option. */
export function canAllowExternalUse(
  item: Pick<CreativeItem, "canEdit" | "generationProvenance">,
): boolean {
  const ceiling = item.generationProvenance?.usageCeiling;
  return item.canEdit && (!ceiling || ceiling === "external_allowed");
}
